module.exports = __webpack_public_path__ + "visa-icon@3x.png?95b6a6e2b75afebe5bacb0e4ae06b114";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visa-icon@3x.png
// module id = 1039
// module chunks = 0